<script>
  export let lang = undefined;

  const i18n = {
    team: {
      cs: 'Tým',
      en: 'Team',
    },
  };
</script>

<div class='standing-legend'>
  <div class='standing-legend-prepend'>
    <div class='standing-legend-prepend-position'> ## </div>

    <div class='standing-legend-prepend-team'> {i18n.team[lang]} </div>
  </div>

  <div class='standing-legend-append'>
    <div class='standing-legend-append-g'> G </div>

    <div class='standing-legend-append-w'> W </div>

    <div class='standing-legend-append-l'> L </div>

    <div class='standing-legend-append-t'> T </div>
  </div>
</div>

<style>
  .standing-legend {
    display: flex;
    justify-content: space-between;
    align-items: center;

    height: 15px;

    padding: 0px 20px;

    text-transform: uppercase;

    font-size: 10px;
    font-weight: 550;

    letter-spacing: 1px;

    color: var(--grey-5);
  }

  .standing-legend-prepend {
    display: flex;
    gap: 20px;
  }

  .standing-legend-prepend-position {
    display: flex;
    justify-content: center;

    width: calc(20px / 3 * 4);
  }

  .standing-legend-prepend-team {
    display: flex;
    justify-content: center;

    width: 150px;
  }

  .standing-legend-append {
    display: flex;
    gap: 10px;
  }

  .standing-legend-append-g {
    display: flex;
    justify-content: center;

    width: 30px;
  }

  .standing-legend-append-w {
    display: flex;
    justify-content: center;

    width: 30px;
  }

  .standing-legend-append-l {
    display: flex;
    justify-content: center;

    width: 30px;
  }

  .standing-legend-append-t {
    display: flex;
    justify-content: center;

    width: 30px;
  }

  :global(body.dark) .standing-legend {
    color: var(--grey-6);
  }

  @media only screen and (max-width: 500px) {
    .standing-legend-append-g {
      display: none;
    }
  }

  @media only screen and (max-width: 450px) {
    .standing-legend-prepend-team {
      width: 75px;
    }
  }
</style>
